import {
  giveLastBitOne,
  giveLastBitZero,
  saveMap,
  uidColorGroupToZero,
  uint32
} from '../utils';
import {
  getThemePreLength,
  getThemeTableLength,
  getThemeTableTotalCount,
  RECORD_LENGTH,
  THEME_EXTENDED_LENGTH,
  THEME_TABLE_PER_ROW_LENGTH,
  THEME_TABLE_PRE_LENGTH
} from './constant';
import { IMG, SPRITE } from './dataSource';

const oldThemeDataDevices = [
  'L61',
  'L61Simulator',
  'L67',
  'M62',
  'M65S',
  'M66',
  'M67',
  'N60',
  'N65',
  'N65A',
  'N65B',
  'N65C'
];

export async function genThemeAndRecordBinary(
  themeData: any,
  themeNum: number,
  HEADER_LENGTH: number,
  xmlPath?: string,
  deviceType?: string,
  WATCHFACE_COLOR_GROUP?: string[]
): Promise<Buffer> {
  let totalRecordNum = 0;
  // todo by 分辨率输出需要修改isThemeExtended为根据WATCHFACE_COLOR_GROUP是否存在判断
  const isThemeExtended =
    deviceType && !oldThemeDataDevices.includes(deviceType);
  const themePreLength = getThemePreLength();
  let recordsOffset = 0;
  let colorGroupTotalCount = 0;
  isThemeExtended &&
    Object.entries(themeData).map(([themeType, themeValue]: [string, any]) => {
      const value = JSON.parse(JSON.stringify(themeValue));
      const themeColorGroupTable = value.colorGroupTable?.length
        ? value.colorGroupTable.split(',')
        : [];
      const colorGroupTableCount = themeColorGroupTable.length ?? 0;
      colorGroupTotalCount += colorGroupTableCount;
    });
  const recordStartAddr =
    HEADER_LENGTH +
    themeNum *
      (themePreLength + (isThemeExtended ? THEME_EXTENDED_LENGTH : 0)) +
    colorGroupTotalCount * 4;
  const previewAddressArr: any[] = [];
  const themeTableTotalCount = getThemeTableTotalCount();
  const themeTableLength = getThemeTableLength();
  let themeTableArr = Object.entries(themeData).map(
    ([themeType, themeValue]: [string, any]) => {
      const value = JSON.parse(JSON.stringify(themeValue));
      console.log(value);
      if (!value.records.length) return Buffer.alloc(0);
      const themeColorGroupTable = value.colorGroupTable?.length
        ? value.colorGroupTable.split(',')
        : [];
      const colorGroupTableCount = themeColorGroupTable.length ?? 0;
      totalRecordNum += value.records.length;
      const themeTable = Buffer.alloc(themeTableLength);
      // v0.70 新增bgColor，previewImgDataAddr字段
      if (value.bgColor && !value.bg) {
        const bgColor = Number(`0x${value.bgColor.slice(3)}`);
        if (isThemeExtended) {
          const themeExtendedColor = giveLastBitOne(bgColor);
          themeTable.writeUInt32LE(themeExtendedColor, 0);
        } else {
          themeTable.writeUInt32LE(giveLastBitZero(bgColor), 0);
        }
      } else if (value.bg && value.bg.indexOf('Sprite') !== -1) {
        const bgSpriteRecord = themeValue.records.find((elem: any) => {
          return (
            elem.name === value.bg.replace('@', '') && elem.type === SPRITE
          );
        });
        const bgSpriteUid = giveLastBitOne(bgSpriteRecord.uid.readInt32LE());
        themeTable.writeUInt32LE(bgSpriteUid, 0);
      } else if (value.bg) {
        const bgRecord = themeValue.records.find((elem: any) => {
          if (!colorGroupTableCount)
            return elem.name === value.bg.replace('@', '') && elem.type === IMG;
          else
            return (
              elem.name === value.bg.replace('@', '') &&
              elem.type === IMG &&
              elem.colorGroup === themeColorGroupTable[0]
            );
        });
        const uid = bgRecord.uid.readInt32LE();
        if (isThemeExtended) {
          const colorUid = uidColorGroupToZero(bgRecord.uid).readInt32LE();
          const themeExtendedBg = giveLastBitOne(colorUid);
          themeTable.writeUInt32LE(themeExtendedBg, 0);
        } else {
          themeTable.writeUInt32LE(uid, 0);
        }
      } else {
        const uid = uint32(0);
        if (isThemeExtended) {
          const colorUid = uidColorGroupToZero(uid).readInt32LE();
          const themeExtendedBg = giveLastBitOne(colorUid);
          themeTable.writeUInt32LE(themeExtendedBg, 0);
        } else {
          themeTable.writeUInt32LE(0, 0);
        }
      }
      let themeExtended = Buffer.alloc(isThemeExtended ? 64 : 0);
      if (isThemeExtended && themeType !== 'dark') {
        themeExtended.write(value.name);
        // const fg = uint32(0);
        const fg = value.fg ? Buffer.from(value.fgUid) : uint32(0);
        themeExtended = Buffer.concat([themeExtended, fg]);
        const type = themeType.toLowerCase().indexOf('normal') !== -1 ? 0 : 1;
        const typeAndColorGroupCount = uint32(
          type + (colorGroupTableCount << 2)
        );
        themeExtended = Buffer.concat([themeExtended, typeAndColorGroupCount]);
        let ColorGroupTable;
        if (themeColorGroupTable.length > 0 && WATCHFACE_COLOR_GROUP) {
          ColorGroupTable = uint32(
            WATCHFACE_COLOR_GROUP.indexOf(themeColorGroupTable[0])
          );
          if (themeColorGroupTable.length > 1) {
            for (let i = 1; i < themeColorGroupTable.length; i++) {
              ColorGroupTable = Buffer.concat([
                ColorGroupTable,
                uint32(WATCHFACE_COLOR_GROUP.indexOf(themeColorGroupTable[i]))
              ]);
            }
          }
          if (ColorGroupTable) {
            themeExtended = Buffer.concat([themeExtended, ColorGroupTable]);
          }
        }
      }

      for (let i = 0; i < themeTableTotalCount; i++) {
        const count = Math.min(value.recordsCount[i], 0xffffffff) >>> 0;
        themeTable.writeUInt32LE(
          count,
          i * THEME_TABLE_PER_ROW_LENGTH + THEME_TABLE_PRE_LENGTH
        );
        const addr = Math.min(recordStartAddr + recordsOffset, 0xffffffff) >>> 0;
        themeTable.writeUInt32LE(
          addr,
          i * THEME_TABLE_PER_ROW_LENGTH + 4 + THEME_TABLE_PRE_LENGTH
        );
        recordsOffset += value.recordsCount[i] * RECORD_LENGTH;
      }
      const preview = value.preview;
      if (preview && preview !== '') {
        previewAddressArr.push(value.previewAddr);
      } else previewAddressArr.push(undefined);
      return Buffer.concat([themeTable, themeExtended]);
    }
  );
  const dataOffset =
    HEADER_LENGTH +
    themeNum *
      (themePreLength + (isThemeExtended ? THEME_EXTENDED_LENGTH : 0)) +
    totalRecordNum * RECORD_LENGTH +
    colorGroupTotalCount * 4;

  themeTableArr = themeTableArr.map((themeTable, index) => {
    if (previewAddressArr[index] !== undefined)
      themeTable.writeInt32LE(dataOffset + previewAddressArr[index], 4);
    return themeTable;
  });
  const recordsArr: Buffer[] = [];
  const nameArr: string[] = [];
  const uidArr: any[] = [];
  Object.entries(themeData).forEach(([key, value]: [string, any]) => {
    value.records.forEach((themeRecord: any) => {
      const record = JSON.parse(JSON.stringify(themeRecord));
      const resUid = Buffer.from(record.uid.data);

      if (record.type !== 0) {
        const name = record.name;
        if (!nameArr.includes(name) || record.colorGroup) {
          const mapUid = Buffer.from(record.uid)
            .reverse()
            .toString('hex')
            .slice(1);
          nameArr.push(name);
          uidArr.push(mapUid);
        }
      }
      const flags = uint32(0);

      const addrValue = record.dataAddress + dataOffset;
      if (addrValue > 0xffffffff) {
        console.warn(`[BIN] dataAddress overflow: record "${record.name}" address ${addrValue} exceeds uint32 limit`);
      }
      const dataAddress = uint32(addrValue);

      const dataLength = uint32(record.dataLength);
      const recordBin = Buffer.concat([resUid, flags, dataAddress, dataLength]);
      recordsArr.push(recordBin);
    });
  });
  xmlPath && (await saveMap(xmlPath, nameArr, uidArr));
  return Buffer.concat([...themeTableArr, ...recordsArr]);
}
